import { render, staticRenderFns } from "./LogNutrition.vue?vue&type=template&id=db72f8f6&scoped=true&lang=pug&"
import script from "./LogNutrition.vue?vue&type=script&lang=js&"
export * from "./LogNutrition.vue?vue&type=script&lang=js&"
import style0 from "./LogNutrition.vue?vue&type=style&index=0&id=db72f8f6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db72f8f6",
  null
  
)

export default component.exports